export default __webpack_public_path__ + "static/GreyCamo-b08a6e5d0678a71f2a38e251031423b6.svg";